<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.certificateNo"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.provinceId"
              filterable
              clearable
              placeholder="请选择省区"
              style="width:100%"
              @change="changeProvinceFun"
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.settingId"
              filterable
              clearable
              placeholder="请选择周期"
              style="width:100%"
              @change="changeSettingIdFun"
            >
              <el-option
                v-for="item in settingIdOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.cityName"
              placeholder="请输入城市名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @edit="editFun(arguments)"
        @view="viewFun(arguments)"
        @efficient="efficientFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
        @exportReport="exportReport(masterList)"
      />
    </div>
    <!-- 新增 修改-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 新增 修改-->
    <export-report-dialog
      :dialog-title="'导出分析报告数据'"
      :dialog-visible.sync="dialogExportReportVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 有效性设置-->
    <efficient-dialog
      :data-id="id"
      :dialog-title="dialogEfficientTitle"
      :dialog-visible.sync="dialogEfficientVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 新增 修改
import AddEditViewDialog from './components/addEditViewDialog'
// 导出报告
import exportReportDialog from './components/exportReportDialog'
// 有效性设置
import EfficientDialog from './components/efficientDialog'
// 数据请求
import { loadAreaDataApi } from '@/api/area'
import { loadRetailSurveyInfoListDataApi, loadRetailSurveyInfoExportDataApi, loadRetailSurveyExportCycleSettingSelectDataApi } from '@/api/retailSurveyInfo'
export default {
  name: 'RetailSurveyInfo',
  components: {
    CustomTable,
    TableOperation,
    AddEditViewDialog,
    exportReportDialog,
    EfficientDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'retail_survey_info_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['retail_survey_info_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['retail_survey_info_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['retail_survey_info_efficient_setting'],
            prop: 'efficient',
            label: '有效性设置',
            method: 'efficient'
          },
          {
            permissionSigns: ['retail_survey_info_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          },
          {
            permissionSigns: ['retail_survey_info_export'],
            prop: 'exportReport',
            label: '导出分析报告',
            method: 'exportReport'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            certificateNo: '',
            provinceId: '',
            cityName: '',
            settingId: '',
            searchStartDate: '',
            searchEndDate: ''
          }
        }
      },
      id: null, // 选中的单据ID
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      dialogExportReportVisible: false,
      dialogEfficientTitle: '',
      dialogEfficientVisible: false,
      eventType: 'edit',
      provinceOptions: [],
      settingIdOptions: []
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 's.province_name', width: 80 },
      { prop: 'cityName', label: '城市', filterColumn: 's.city_name', width: 80 },
      { prop: 'countyName', label: '区县', filterColumn: 's.county_name', width: 100 },
      { prop: 'certificateNo', label: '专卖证号', filterColumn: 's.certificate_no', width: 160 },
      { prop: 'storeName', label: '零售户名称', filterColumn: 's.store_name', width: 160 },
      { prop: 'receiptDayStr', label: '到货周期', filterColumn: '(case i.receipt_day when 1 then \'周一\' when 2 then \'周二\' when 3 then \'周三\' when 4 then \'周四\' when 5 then \'周五\' when 6 then \'周六\' when 7 then \'周日\' else \'\' end)', width: 120 },
      { prop: 'periodReceiptDateStr', label: '本周期到货日期', filterColumn: 'if(i.period_receipt_date is null, \'\', date_format(i.period_receipt_date,\'%Y-%m-%d\'))', width: 150 },
      { prop: 'levelStr', label: '当前档位', filterColumn: 's.level_str', width: 80 },
      { prop: 'levelName', label: '采集档位', filterColumn: 'i.level_name', width: 80 },
      { prop: 'collectionDateStr', label: '采集时间', filterColumn: 'i.collection_date', width: 110, isBetween: true },
      { prop: 'collectionDay', label: '采集周日期', filterColumn: 'i.collection_day', width: 120 },
      { prop: 'collectionUserName', label: '采集人', filterColumn: 'i.collection_user_name', width: 100 },
      { prop: 'collectionTypeStr', label: '采集方式', filterColumn: '(case i.collection_type when 1 then \'现场\' when 2 then \'电话\' else \'\' end)', width: 120 },
      { prop: 'isCollectStr', label: '是否采集', filterColumn: '(case i.is_collect when 1 then \'是\' else \'否\' end)', width: 120 },
      { prop: 'noCollectReasonStr', label: '未采集原因', filterColumn: '(case i.no_collect_reason when 1 then \'未售\' when 2 then \'不配合\' when 3 then \'关门\' when 4 then \'其他\' when 5 then \'未售(不愿意订)\' when 6 then \'未售(订不到)\' else \'\' end)', width: 140 },
      { prop: 'collectStatusStr', label: '采集状态', filterColumn: '(case i.collect_status when 1 then \'已提交\' else \'采集中\' end)', width: 120 },

      { prop: 'weekSalesAmount', label: '本周总销量(条)', filterColumn: 'i.week_sales_amount', width: 140, isBetween: true, isColumnFontColor: true, columnFontColor: '#FF0000' },
      { prop: 'yunWeekSalesAmount', label: '本周云产烟总销量(条)', filterColumn: 'i.yun_week_sales_amount', width: 180, isBetween: true, isColumnFontColor: true, columnFontColor: '#FF0000' },
      { prop: 'salesRate', label: '云产社会销量占比', filterColumn: 'if(i.week_sales_amount is null,\'\',concat(truncate((ifnull(i.yun_week_sales_amount,0)/i.week_sales_amount)*100,2),\'%\'))', width: 180, isColumnFontColor: true, columnFontColor: '#FF0000' },

      { prop: 'inventoryAmount', label: '当前总库存(条)', filterColumn: 'i.inventory_amount', width: 160, isBetween: true, isColumnFontColor: true, columnFontColor: '#0000FF' },
      { prop: 'yunInventoryAmount', label: '当前云产烟总库存(条)', filterColumn: 'i.yun_inventory_amount', width: 180, isBetween: true, isColumnFontColor: true, columnFontColor: '#0000FF' },
      { prop: 'yunInvSalesRate', label: '云产周社会存销比', filterColumn: 'if(i.yun_week_sales_amount is null,\'\',truncate((ifnull(i.yun_inventory_amount,0)/i.yun_week_sales_amount),2))', width: 180, isColumnFontColor: true, columnFontColor: '#0000FF' },
      { prop: 'invSalesRate', label: '大盘周社会存销比', filterColumn: 'if(i.week_sales_amount is null,\'\',truncate((ifnull(i.inventory_amount,0)/i.week_sales_amount),2))', width: 180, isColumnFontColor: true, columnFontColor: '#0000FF' },

      { prop: 'itemInventoryAmount', label: '采集品规库存合计(条)', filterColumn: 'i.item_inventory_amount', width: 180, isBetween: true, isColumnFontColor: true, columnFontColor: '#FF0000' },
      { prop: 'itemYunInventoryAmount', label: '采集云产烟品规库存合计(条)', filterColumn: 'i.item_yun_inventory_amount', width: 210, isBetween: true, isColumnFontColor: true, columnFontColor: '#FF0000' },
      { prop: 'itemInventoryRate', label: '明细总库存占比', filterColumn: 'concat(i.item_inventory_rate,\'%\')', width: 160, isBetween: true, isColumnFontColor: true, columnFontColor: '#FF0000' },
      { prop: 'itemYunInventoryRate', label: '明细云产烟库存占比', filterColumn: 'concat(i.item_yun_inventory_rate,\'%\')', width: 190, isBetween: true, isColumnFontColor: true, columnFontColor: '#FF0000' },

      { prop: 'itemSalesAmount', label: '采集品规销售合计(条)', filterColumn: 'i.item_sales_amount', width: 180, isBetween: true, isColumnFontColor: true, columnFontColor: '#0000FF' },
      { prop: 'itemYunSalesAmount', label: '采集云产烟品规销售合计(条)', filterColumn: 'i.item_yun_sales_amount', width: 210, isBetween: true, isColumnFontColor: true, columnFontColor: '#0000FF' },

      { prop: 'offsetDistance', label: '偏移距离', filterColumn: 'i.offset_distance', width: 120 },
      { prop: 'isEfficientStr', label: '是否有效', filterColumn: '(case i.is_efficient when 1 then \'有效\' else \'无效\' end)', width: 120 },
      { prop: 'noEfficientReason', label: '无效原因', filterColumn: 'i.no_efficient_reason', width: 160 },
      { prop: 'efficientOperatorName', label: '设置人', filterColumn: 'i.efficient_operator_name', width: 120 },
      { prop: 'efficientOperationTimeStr', label: '设置时间', filterColumn: 'i.efficient_operation_time', width: 160, isBetween: true },
      { prop: 'operationTimeStr', label: '操作时间', filterColumn: 'i.operation_time', width: 160 }
    ]
    this.initProvinceSelectData()
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadRetailSurveyInfoListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 初始省区下拉数据
    initProvinceSelectData () {
      loadAreaDataApi({ parentId: 1, isUserArea: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 省区选择回调
    changeProvinceFun (val) {
      this.settingIdOptions = []
      this.masterList.tableQuery.search.settingId = ''
      this.masterList.tableQuery.search.searchStartDate = ''
      this.masterList.tableQuery.search.searchEndDate = ''
      if (val === null || val === '') {
        return false
      }
      this.initSettingSelectData(val)
    },
    // 初始期数下拉数据
    initSettingSelectData (val) {
      loadRetailSurveyExportCycleSettingSelectDataApi({ provinceId: val, orderCondition: 'order by id desc limit 20' }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.settingIdOptions.push({ label: item.name, data: item.id, startDate: item.startDateStr, endDate: item.endDateStr })
        })
      })
    },
    // 周期选择
    changeSettingIdFun (val) {
      this.masterList.tableQuery.search.searchStartDate = ''
      this.masterList.tableQuery.search.searchEndDate = ''
      let selectItem = this.settingIdOptions.find(item => {
        return item.data === val
      })
      if (selectItem) {
        this.masterList.tableQuery.search.searchStartDate = selectItem.startDate
        this.masterList.tableQuery.search.searchEndDate = selectItem.endDate
      }
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '修改零售监测'
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '查看零售监测'
    },
    // 有效性设置
    efficientFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.dialogEfficientVisible = !this.dialogEfficientVisible
      this.dialogEfficientTitle = '有效性设置'
    },
    // 导出报告数据
    exportReport () {
      this.dialogExportReportVisible = !this.dialogExportReportVisible
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadRetailSurveyInfoExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
